import APIService from 'src/services/APIService'

const api = APIService()

export const getOrganisationUsers = payload =>
  api.get(`/users/organisation/${payload.id}?${payload.query}`)
